import BaseApi from '@/api/Base/BaseApi'
import { GetUserAndWorkspaceResponse, HealthCheckResponse } from '@/api/OnPremise/types'

const ROOT = '/on-premise'

export default class OnPremiseApi extends BaseApi {
  healthCheck() {
    return this.agent.get<HealthCheckResponse>(`${ROOT}/health-check`)
  }

  getUserAndWorkspace() {
    return this.agent.get<GetUserAndWorkspaceResponse>(`${ROOT}/user`)
  }

  cancelAllTasks() {
    return this.agent.post(`${ROOT}/cancel-all-tasks`)
  }
}
